import "./src/styles/global.css"

export const shouldUpdateScroll = args => {
  if (!window.location.href.includes("#")) {
    window.scrollTo(...([0, 0]))
  }
  return false
};